import { render, staticRenderFns } from "./MSecondaryWiz.vue?vue&type=template&id=5027db07&"
import script from "./MSecondaryWiz.ts?vue&type=script&lang=ts&"
export * from "./MSecondaryWiz.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports